import _has from 'lodash/has';

export function startSessionHelper(initialAuth, store) {
  // *** isLoggedIn
  store.commit('setState', {
    path: 'sessionExists',
    value: true,
  });

  if (_has(initialAuth, 'auth_header')) {
    store.commit('setState', {
      path: 'authHeader',
      value: initialAuth.auth_header,
    });
  }
}

export default {
  startSessionHelper
};
